/**
 * Smart backend URL resolution.
 *
 * `REACT_APP_BACKEND_URL` gets baked into the React bundle at build time.
 * If the build was done in preview but the bundle is being served from
 * production (or vice versa), the baked URL would point to the wrong
 * environment. To prevent this:
 *
 *   1. If the env URL matches the current window.origin -> use it as-is.
 *   2. If the env URL points elsewhere -> fall back to window.origin.
 *      This means the frontend always talks to the backend on the same
 *      host it was loaded from (works because Kubernetes ingress routes
 *      `/api/*` to the backend on the same host).
 *   3. Server-side / no window (SSR or build) -> use the env value as-is.
 */
const ENV_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

function resolveBackendUrl() {
  if (typeof window === 'undefined' || !window.location) {
    return ENV_URL;
  }
  const currentOrigin = window.location.origin;
  // Same origin -> use env URL (it matches anyway, but normalises trailing slash)
  if (ENV_URL && ENV_URL === currentOrigin) {
    return ENV_URL;
  }
  // localhost dev -> respect the env value (developer might point to remote backend)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return ENV_URL || currentOrigin;
  }
  // Different host (e.g., env=preview but served from production) -> use current origin
  return currentOrigin;
}

export const BACKEND_URL = resolveBackendUrl();
export const API_BASE = `${BACKEND_URL}/api`;
